import { useQueryClient } from '@tanstack/react-query'

import { useAuth } from '../useAuth/useAuth'
import { useClient } from '../useClient/useClient'

export type UseLogoutReturn = Readonly<{
  logout: () => Promise<void>
}>

export const useLogout = (): UseLogoutReturn => {
  const authState = useAuth()
  const { gsClient } = useClient()
  const queryClient = useQueryClient()

  const handleLogout = async () => {
    authState.dispatch({ type: 'LOADING' })
    queryClient.removeQueries()
    await gsClient.post('v1/auth/logout')
    authState.logout()
  }

  return { logout: handleLogout }
}
